import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { getInitialTheme } from './lib/useTheme';

// WHY: Resolve the theme before first paint to avoid a flash of unstyled content.
// Default is dark; a prior toggle persists in localStorage and overrides the default.
(function applyInitialTheme() {
  const theme = getInitialTheme();
  document.documentElement.classList.toggle('dark', theme === 'dark');
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
